export enum DownloadTypeEnum {
    CableFilling = 'cablefilling',
    Kts = 'kts'
}
